import React from 'react'
import MaterialSymbol from 'components/material-symbol/material-symbol'

const createMessagingActionIcon = name => {
  const Icon = ({ className }) => (
    <MaterialSymbol
      name={name}
      className={className}
      fontSize={20}
      htmlColor="#172024"
    />
  )

  Icon.displayName = `Messaging${name
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')}Icon`

  return Icon
}

export const MessagingActionsIcon = createMessagingActionIcon('more_horiz')
export const MessagingThreadIcon = createMessagingActionIcon('reply')
export const MessagingReactionIcon = createMessagingActionIcon(
  'sentiment_satisfied',
)
